<section class="info-card info-card--secondary">
    <div class="info-card__header">
      <h3>{{ 'app.components.courseRating.title' | translate }}</h3>
      <p>{{ 'app.components.courseRating.description' | translate }}</p>
    </div>
    <div class="rating-grid">
      <button
        class="rating-grid__item"
        *ngFor="let rating of ratingScale; let i = index"
        [disabled]="!canRate"
        [class.rating-grid__item--disabled]="disabled()"
        (mouseenter)="setHovered(i)"
        (mouseleave)="setHovered(null)"
        [class.rating-grid__item--gold]="isRatingActive(rating, i)"
        [class.rating-grid__item--muted]="hoveredIndex !== null && i > hoveredIndex && !isVoted"
        (click)="rateCourse(rating)"
      >
        <img 
          *ngIf="isRatingActive(rating, i)"
          src="/public/svgs/rate-active.svg" 
          alt="Star"
          class="rating-grid__icon"
        >
        <img 
          *ngIf="!isRatingActive(rating, i)"
          src="/public/svgs/rate-inactive.svg" 
          alt="Star"
          class="rating-grid__icon"
        >
        {{ rating }}
      </button>
    </div>
  </section>